import styled, { css } from 'styled-components'

export const IdWithNotes = styled.div`
  display: flex;
  align-items: center;
  width: 100px;
  gap: 5px;
`
const EmailAndPhoneStyle = css`
  font-weight: 600;
  letter-spacing: 0.24px;
  white-space: nowrap;
  color: #000;
`

export const Phone = styled.div`
  ${EmailAndPhoneStyle}
`

export const EmailLink = styled.a`
  ${EmailAndPhoneStyle}
`
